const convertDateToString = (strDateTime) => {
    if(strDateTime){
        const date = new Date(strDateTime);
        return date.toLocaleDateString("en-US");
    }
    return strDateTime;
}

export default convertDateToString;